<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">

        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">User</div>
                    <div class="pagebutton" v-if="user_role == 1">
                        <button v-if="!is_Update" type="button" class="ml-2 btn btn-primary pull-right" v-on:click="EditButton()"><i class="fa fa-pencil"></i></button>
                    </div>
                </div>
                <!--Forms-->
                <form>
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-12 forms-block common-disable">
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">First Name :</div>
                                    </div>

                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" v-validate="'required'" class="form-control" v-model="first_name" id="first_name" placeholder="Enter First Name" name="first_name">
                                        <span v-show="errors.has('first_name')" class="help is-danger">The First Name is Required.</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Last Name :</div>
                                    </div>

                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" v-validate="'required'" class="form-control" v-model="last_name" id="last_name" placeholder="Enter Last Name" name="last_name">
                                        <span v-show="errors.has('last_name')" class="help is-danger">The Last Name is Required.</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">E-mail :</div>
                                    </div>

                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <span class="form-control" v-html="email"></span>
                                    </div>
                                </div>

                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Password :</div>
                                    </div>

                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" v-validate="'required'" class="form-control" v-model="password" id="password" placeholder="Enter Password" name="password">
                                        <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <div class="mr-17 pb-2 float-l" v-if="is_Update">
                                    <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="cancelUserDetails()"><span>Cancel</span></button>
                                    <button type="submit" id="createAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="editUserDetails()"><span>Edit</span></button>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    Vue.component("app-footer", Footer);
    
    export default {
        name: 'UserList',
        mixins: [commonMixins],
        data() {
            return {
                user_id: "",
                first_name: "",
                last_name: "",
                email: "",
                password: "",
                is_Update: false,
            }
        },
        created: function () {

        },
        mounted: function () {
            var self = this;
            $('.common-disable :input').attr('disabled', true);
            self.loadUser();
        },
        methods: {
            cancelUserDetails: function () {
                var self = this;
                self.is_Update = false;
                $('.common-disable :input').attr('disabled', true);
            },
            EditButton: function () {
                var self = this;
                self.is_Update = true;
                $('.common-disable :input').removeAttr('disabled');
            },

            loadUser: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.showLoader();
                HTTP.get("get_users", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                //console.log("User Gets" + response.data.content);
                                self.user_id = response.data.content.id;
                                self.first_name = self.formatString(response.data.content.first_name);
                                self.last_name = self.formatString(response.data.content.last_name);
                                self.email = response.data.content.email;
                                self.password = response.data.content.password;
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            editUserDetails: function () {
                var self = this;

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                var fields = {
                    id: self.user_id,
                    first_name: self.first_name,
                    last_name: self.last_name,
                    email: self.email,
                    password: self.password,
                };

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        self.showLoader();
                        HTTP.post('store_user_details', fields, config)
                                .then(function (response) {

                                    if (response.data.status == "success") {

                                        self.is_Update = false;
                                        $('.common-disable :input').attr('disabled', true);
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });

                    }
                });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/UserList.vue